import { SpacingName, ThemedFunctor, getSpacing } from '@doveit/bricks';
import { css } from 'styled-components';

export const coveredGeoDashedLine: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.margin(theme, [0, SpacingName.SMALLER, 0])};
  border: none;
  border-top: 1px dashed ${theme.palettes.neutrals.light};
  flex-grow: 1;
`;
